import Sdk from 'api.digitalpages.module.sdk.api';
var utils = function () {
  this.parseDateString = function (dateString) {
    const months = {
      janeiro: 0,
      fevereiro: 1,
      março: 2,
      abril: 3,
      maio: 4,
      junho: 5,
      julho: 6,
      agosto: 7,
      setembro: 8,
      outubro: 9,
      novembro: 10,
      dezembro: 11
    };
  
    try {
      const [day, monthName, year] = dateString.split(' de ');
      const month = months[monthName.toLowerCase()];
    
      return new Date(year, month, day);
    } catch (e) {
      return new Date(dateString)
    }
  }
  
  this.localeDate = function (date) {
    const current = date;
    let day = current.getDate();
    let month = String(Number(current.getUTCMonth()) + 1);
    const year = current.getUTCFullYear();
    
    if (day.length === 1) day = `0${day}`
    if (month.length === 1) month = `0${month}`
    return `${day}/${month}/${year}`
  };

  this.getCustomizationConfig = function (uid, prop) {
    var config = null;
    var customization = JSON.parse(window.localStorage.getItem("customization"));

    if (customization) {
      config = JSON.parse(customization.find(item => item.uid === uid).value).find(obj => obj.uid === prop).value;
    }

    return config;
  }

  this.getUrlParams = function () {
    var splittedUrl = window.location.href.split("?")[1];
    var tempParams = [];
    var params = [];
    if (splittedUrl !== undefined) {
      var splittedParams = splittedUrl.split("&");
  
      if (splittedParams.length > 1) {
        tempParams = tempParams.concat(splittedParams);
      } else {
        tempParams.push(splittedUrl);
      };
  
      for (var i = 0; i < tempParams.length; i++) {
        var param = tempParams[i].split("=")[0];
        var value = tempParams[i].split("=")[1];
        params.push({
          "param": param,
          "value": value
        });
      };
    };
    
    return params;
  };

  this.getUrlParam = function (param) {
    var params = this.getUrlParams();
    var searchedParam = params.find(par => par.param === param);
    return searchedParam ? searchedParam.value : null;
  };


  this.bridgeAndStore = async function(route, data, method) {
    var response = await Sdk.Api.dynamic.bridge(route, data, method);
    window.localStorage.setItem(route, JSON.stringify(response));
    return response;
  }

  this.recoverBridge = function(route) {
    if (window.localStorage.getItem(route) !== null) {
      return JSON.parse(window.localStorage.getItem(route));
    } else {
      return null;
    }
  }

  this.mobileHapticFeeback = function()
  {
    Sdk.Api.dynamic.bridge("/system/action?event=hapticfeedback&type=click", null, "POST")
    .then(p=> console.log('hapticfeedback: ok'))
    .catch(p=> console.log('hapticfeedback: fail'));
  }

  this.mobileVibrate = function()
  {
    Sdk.Api.dynamic.bridge("/system/action?event=vibrate", null, "POST")
    .then(p=> console.log('vibrate: ok'))
    .catch(p=> console.log('vibrate: fail'));
  }

  return this;
}

var Utils = new utils();

export {
  Utils
};